// @flow
import { DAYS, MINUTES, MONTHS } from './time-units';

export const TODAY = {
    constant: 'TODAY',
    intlKey: 'today',
    timeUnit: MINUTES,
    rate: 30,
    resolution: 'day'
};
export const YESTERDAY = {
    constant: 'YESTERDAY',
    intlKey: 'yesterday',
    timeUnit: MINUTES,
    rate: 30,
    resolution: 'day'
};

export const THIS_WEEK = {
    constant: 'THIS_WEEK',
    intlKey: 'thisWeek',
    timeUnit: DAYS,
    rate: 1,
    resolution: 'week'
};
export const LAST_WEEK = {
    constant: 'LAST_WEEK',
    intlKey: 'lastWeek',
    timeUnit: DAYS,
    rate: 1,
    resolution: 'week'
};
export const THIS_MONTH = {
    constant: 'THIS_MONTH',
    intlKey: 'thisMonth',
    timeUnit: DAYS,
    rate: 1,
    resolution: 'month'
};
export const LAST_MONTH = {
    constant: 'LAST_MONTH',
    intlKey: 'lastMonth',
    timeUnit: DAYS,
    rate: 1,
    resolution: 'month'
};
export const THIS_YEAR = {
    constant: 'THIS_YEAR',
    intlKey: 'thisYear',
    timeUnit: MONTHS,
    rate: 1,
    resolution: 'year'
};



// WEBPACK FOOTER //
// ./src/core/constants/periods.js